import { render, staticRenderFns } from "./UserSubscriptions.vue?vue&type=template&id=40dea6be&"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js&"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40dea6be')) {
      api.createRecord('40dea6be', component.options)
    } else {
      api.reload('40dea6be', component.options)
    }
    module.hot.accept("./UserSubscriptions.vue?vue&type=template&id=40dea6be&", function () {
      api.rerender('40dea6be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserSubscriptions.vue"
export default component.exports